/* Small global behaviours.

   1. Exclusive accordions. A <details data-kz-exclusive="group"> closes the
      other open ones in its group when it opens. Modern browsers do this
      natively through the name attribute, which the markup also carries;
      this covers the ones that predate it. Harmless where both run.

   2. Footer columns. On a phone they are closed accordions, one open at a
      time. From 761px every column is held open and the name attribute is
      lifted, or the native exclusivity would shut all but one. */

(() => {
  if (window.__kozaUi) return;
  window.__kozaUi = true;

  // toggle does not bubble, so listen in the capture phase.
  document.addEventListener(
    'toggle',
    (e) => {
      const d = e.target;
      if (!(d instanceof HTMLDetailsElement) || !d.open) return;
      const group = d.dataset.kzExclusive;
      if (!group) return;
      document.querySelectorAll(`details[data-kz-exclusive="${CSS.escape(group)}"][open]`).forEach((o) => {
        if (o !== d) o.open = false;
      });
    },
    true
  );

  const cols = () => document.querySelectorAll('[data-kz-footcol]');
  const mq = window.matchMedia('(min-width: 761px)');
  const applyFooter = () => {
    const wide = mq.matches;
    cols().forEach((d) => {
      if (wide) {
        // Lift both the native and the scripted exclusivity, or opening the
        // second column closes the first again.
        d.removeAttribute('name');
        d.removeAttribute('data-kz-exclusive');
        d.open = true;
      } else {
        d.setAttribute('name', 'kz-foot');
        d.setAttribute('data-kz-exclusive', 'kz-foot');
        d.open = false;
      }
    });
  };
  const ready = () => {
    applyFooter();
    if (mq.addEventListener) mq.addEventListener('change', applyFooter);
    else mq.addListener(applyFooter);
    // Theme editor re-renders the footer section; run again when it does.
    document.addEventListener('shopify:section:load', applyFooter);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();
